import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "smooth" }); // Only scroll to top if no hash
    }
  }, [pathname]); // Trigger only on pathname change

  return null;
};

export default ScrollToTop;
